import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService, User } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  private authService: AuthService = inject(AuthService)
  private router: Router = inject(Router)

  canActivate(route: ActivatedRouteSnapshot): boolean {
    let isAuthenticated: boolean;
    if (this.authService.isAuthenticated()) {
      isAuthenticated = true;
    } else if (typeof window !== 'undefined' && window.localStorage && window.sessionStorage) {
      const token = window.sessionStorage.getItem('currentUser') || window.localStorage.getItem('currentUser')
      if (!token) {
        isAuthenticated = false
      } else {
        const user: User = this.authService.decodeToken(token)
        console.log('new Date',)
        isAuthenticated = user.exp > new Date
        // this.authService.currentUser$.next(user)
      }

      /* TODO: Dodać powiadomienie o wygaśnięciu tokena */
    } else {
      isAuthenticated = false;
    }

    if (!isAuthenticated) {

      // Redirect to login with return URL
      const returnUrl = route.url.map(segment => segment.path).join('/');
      this.router.navigate(['/login'], { queryParams: { returnUrl: `/${returnUrl}` } });
    }
    return isAuthenticated
  }
} 